const NotFound = () => {
    return (
        <h1 className="title">404 - Page Not Found</h1>
    )
}

export default NotFound;